import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCheck, FaArrowLeft } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from '../components/Navbar';
import './ServicePage.css';

const StaticMobileApp = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      offset: 100
    });
    window.scrollTo(0, 0);
  }, []);

  const features = [
    'Android & iOS static apps',
    'Beautiful clean UI',
    'Offline support',
    'Brand-matching theme',
    'Click-to-call, location, social links',
    'Basic navigation screens'
  ];

  const bestFor = [
    'Hotels',
    'Consultants',
    'Service providers',
    'Shops',
    'Personal brands'
  ];

  return (
    <div className="service-page">
      <Navbar />
      <div className="service-hero">
        <Link to="/" className="back-button" data-aos="fade-right">
          <FaArrowLeft /> Back to Home
        </Link>
        <div className="service-hero-content" data-aos="fade-up">
          <h1 className="service-page-title">Static Mobile App Development</h1>
          <p className="service-hero-tagline">Affordable, lightweight mobile apps to establish your app presence.</p>
        </div>
      </div>

      <div className="service-content">
        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Overview</h2>
          <p className="section-text">
            We create basic static apps that display your business information, services, products, and contact details 
            inside a mobile app interface.
          </p>
        </div>

        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">What You Get</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-item" data-aos="fade-up" data-aos-delay={index * 50}>
                <FaCheck className="check-icon" />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Best For</h2>
          <div className="ideal-for-list">
            {bestFor.map((item, index) => (
              <div key={index} className="ideal-item" data-aos="fade-up" data-aos-delay={index * 100}>
                {item}
              </div>
            ))}
          </div>
        </div>

        <div className="service-cta" data-aos="fade-up">
          <Link to="/contact" className="cta-button-primary">
            Get Your App Built →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default StaticMobileApp;

